var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.nodes, function (node, idx) {
      return _c(
        "ul",
        {
          key: _vm.getkey(node, idx),
          staticClass: "list-group list-group-flush",
        },
        [
          _c(
            "li",
            {
              staticClass: "list-group-item d-flex justify-content-between",
              on: {
                click: function ($event) {
                  node.collapsed = !node.collapsed
                },
              },
            },
            [
              _c("div", [_vm._v(_vm._s(node.name))]),
              _vm._v(" "),
              _c("span", [
                _c("i", {
                  staticClass: "fa",
                  class: node.collapsed ? "fa-chevron-down" : "fa-chevron-up",
                  attrs: { "aria-hidden": "true" },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "collapse" } }, [
            node.children
              ? _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !node.collapsed,
                        expression: "!node.collapsed",
                      },
                    ],
                    staticClass: "list-group list-group-flush",
                  },
                  [
                    _vm._l(node.children, function (child, idxChild) {
                      return child.behavior == "group"
                        ? _c("RecursiveTreeGroupedLinks", {
                            key: `RecursiveTreeGroupedLinks-${
                              child?.id ?? "1"
                            }-${idxChild}`,
                            staticClass: "space-left",
                            attrs: { nodes: [child] },
                          })
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(node.children, function (child, idxChild) {
                      return child.url || child.filename
                        ? _c(
                            "a",
                            {
                              key: `list-group-item-${
                                child?.id ?? "1"
                              }-${idxChild}`,
                              staticClass: "list-group-item",
                              attrs: {
                                href: child.url
                                  ? child.url
                                  : _vm.getFormatUrlAPI(child.filename),
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(child.name) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e()
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }